import { render, staticRenderFns } from "./StockExpense.vue?vue&type=template&id=190428a2&scoped=true&"
import script from "./StockExpense.vue?vue&type=script&lang=js&"
export * from "./StockExpense.vue?vue&type=script&lang=js&"
import style0 from "./StockExpense.vue?vue&type=style&index=0&id=190428a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190428a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VAlert,VAutocomplete,VBtn,VCard,VDataTable,VOverlay,VProgressCircular,VSkeletonLoader})
